import { ProgressBar } from '../widgets/ProgressBar'
import { formatMeasure } from '../format'
import { QueryResult, ViewConfig } from '../view-config'

/**
 * Ranked-list view: the breakdown's groups as a leaderboard — rank, label, a
 * magnitude bar relative to the top group, and the measure value. Pairs with
 * the "Show top N" limit for "top 10 owners by revenue"-style widgets. Groups
 * arrive pre-sorted (and limited) from the engine.
 */
export function RankedListView({
  config,
  result,
}: {
  config: ViewConfig
  result: QueryResult
}) {
  if (result.kind !== 'aggregate') return null
  const label = config.chartMetric ?? config.metrics?.[0]?.label ?? ''
  const format = (n: number) => formatMeasure(label, n)

  const { groups } = result
  if (groups.length === 0) {
    return (
      <p className="py-10 text-center text-sm text-fg-secondary">
        No data to rank.
      </p>
    )
  }
  const max = Math.max(...groups.map((g) => g.metrics[label] ?? 0), 1)

  return (
    <div className="flex flex-col divide-y divide-line">
      {groups.map((g, i) => {
        const value = g.metrics[label] ?? 0
        return (
          <div key={g.key} className="flex items-center gap-3 py-2.5">
            <span className="w-5 shrink-0 text-sm font-semibold tabular-nums text-fg-secondary">
              {i + 1}
            </span>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-medium text-fg">{g.key}</p>
              <ProgressBar
                value={(value / max) * 100}
                className="mt-1 w-full"
              />
            </div>
            <span className="w-28 shrink-0 text-right text-sm font-semibold tabular-nums text-fg">
              {format(value)}
            </span>
          </div>
        )
      })}
    </div>
  )
}
